import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Reveal } from "./Reveal";
import { CLASSES, IMAGES } from "../../data";

export default function Classes() {
  const navigate = useNavigate();
  const goBook = () => {
    navigate("/book");
    window.scrollTo({ top: 0 });
  };

  const borderAccent = {
    pink: "hover:border-hotpink/60",
    teal: "hover:border-teal/60",
  };
  const tagColor = {
    pink: "text-hotpink",
    teal: "text-teal",
  };

  return (
    <section
      id="classes"
      className="relative bg-[#0C0C0C] py-24 md:py-36 px-6 lg:px-10"
      data-testid="classes-section"
    >
      <div className="mx-auto max-w-[1400px]">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <Reveal>
              <p className="font-body text-xs md:text-sm uppercase tracking-[0.3em] text-teal mb-6">
                / Programs
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-display font-700 uppercase leading-[0.9] tracking-tighter text-white text-5xl md:text-6xl lg:text-7xl">
                Train the eight limbs
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-xs font-body text-sm text-neutral-400 leading-relaxed">
              Authentic Muay Thai for beginners, experienced students, youth,
              and fighters.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {CLASSES.map((c, i) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: i * 0.1 }}
              data-testid={`class-card-${i}`}
              className={`group relative overflow-hidden rounded-lg border border-white/10 bg-[#121212] p-8 md:p-9 flex flex-col ${borderAccent[c.accent]} transition-colors duration-500 ${c.span}`}
            >
              {c.img && (
                <div className="absolute inset-0">
                  <img
                    src={IMAGES[c.img]}
                    alt=""
                    className="h-full w-full object-cover opacity-25 group-hover:opacity-40 group-hover:scale-105 transition-[opacity,transform] duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#121212] via-[#121212]/85 to-[#121212]/60" />
                </div>
              )}
              <div className="relative">
                <span
                  className={`font-body text-[11px] uppercase tracking-[0.25em] ${tagColor[c.accent]}`}
                >
                  {c.tag}
                </span>
                <h3 className="mt-4 font-display uppercase tracking-tight text-2xl md:text-3xl lg:text-4xl text-white">
                  {c.title}
                </h3>
                <p className="mt-4 max-w-2xl font-body text-sm md:text-base text-neutral-300 leading-relaxed">
                  {c.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-14 flex flex-col md:flex-row md:items-center md:justify-between gap-6 rounded-2xl border border-white/10 bg-[#121212] p-7 md:p-9">
            <p className="font-body text-base md:text-lg text-neutral-300 max-w-2xl">
              Everyone starts somewhere. Come train with us — your first class is free.
            </p>
            <button
              onClick={goBook}
              data-testid="classes-book-btn"
              className="font-display uppercase tracking-wide text-base px-8 py-4 bg-hotpink text-white hover:bg-white hover:text-ink transition-colors duration-300 rounded-sm hover:drop-shadow-[0_0_20px_rgba(255,20,147,0.5)]"
            >
              Book Your Free Class
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
